import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './plugins/i18n'
import SvgIcon from '@/components/Common/SvgIcon'
import ElementUI from 'exarcheia-element/lib/index'
import locale from 'exarcheia-element/lib/locale/lang/ru-RU'

import '@/directives'
import '@/filters'
import '@/assets/scss/core/app.scss'
import '@/assets/scss/element/app.scss'
// Todo: может создадим 1 файл в корне в который будут стекаться все прочие импорты?. много файлов app.scss очень путает
import '@/assets/scss/index.scss'

Vue.use(ElementUI, { locale })
Vue.config.productionTip = false
Vue.component('svg-icon', SvgIcon)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
